<div mat-dialog-title
     class="title">
    <div class="subtitle">{{ formTitle | translate }}</div>
    <button mat-icon-button
            mat-dialog-close
            tabindex="-1"
            [matTooltip]="'Close' | translate"
            class="close-button hidden">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="line line-margin">
        <mat-form-field color="primary">
            <mat-select placeholder="{{ 'Athlete_Attribution' | translate }}"
                        [formControl]="athletesSelectFormControl"
                        multiple
                        #multiSelect>
              <ngx-mat-select-search
                [placeholderLabel]="'Search' | translate"
                [noEntriesFoundLabel]="'No_Entries_Found' | translate"
                [formControl]="athleteFilterFormControl">
              </ngx-mat-select-search>
                <mat-option *ngFor="let athlete of filteredAthletes |async" [value]="athlete">
                    {{ athlete.firstName + ' ' + athlete.lastName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button
            mat-dialog-close
            tabindex="-1">
        {{ 'Cancel' | translate}}
    </button>
    <button mat-raised-button
            (click)="onSaveClicked()"
            color="accent">
        {{ 'Save' | translate}}
    </button>
</mat-dialog-actions>
<div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
